import ReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ReverseChargeDeterminer";
import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";

export default class ForeignCustomerWithIcReverseChargeDeterminer
  implements ReverseChargeDeterminer
{
  private foreignCustomerDeterminer: ForeignCustomerDeterminer;

  constructor(foreignCustomerDeterminer: ForeignCustomerDeterminer) {
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
  }

  async determinate(
    country: string | null = null,
    ic: string | null = null,
  ): Promise<boolean> {
    return (
      this.foreignCustomerDeterminer.isForeignCustomer(country) &&
      ic !== null &&
      ic !== ""
    );
  }
}
